import axios from "axios";
import * as Sentry from "@sentry/react";

const apiCMS = axios.create({
  baseURL: `${process.env.REACT_APP_CMS_API_URL}`,
});

apiCMS.interceptors.response.use(
  (response) => response,
  (error) => {
    const sentryError = new Error(error.message);
    Sentry.captureException(sentryError, (scope) => {
      scope.setTransactionName(`CMS Api: ${error.code}`);
      scope.setTag("CMS Api", error.code);
      scope.setExtra("data", error);
    });
    return Promise.reject(error);
  }
);

export default apiCMS;
